import { shuffle } from 'lodash-es';
import { PROVIDER_SERVICES } from '@/constants';
import {
  getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults as SEOSegmentationProviderSearchResult,
  getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults_seniorAssistedLivingCenterAttributes_rooms as SeniorAssistedLivingCenterRooms,
} from '@/__generated__/getSearchResults';

const convertServicesToStrings = (
  attributes:
    | SEOSegmentationProviderSearchResult['seniorAssistedLivingCenterAttributes']
    | SeniorAssistedLivingCenterRooms
): string[] => {
  if (!attributes) return [];

  return Object.entries(attributes).flatMap(([key, value]) => {
    if (typeof value === 'object' && value !== null) {
      return Object.entries(value)
        .filter(([, isActive]) => isActive)
        .map(([nestedKey]) => PROVIDER_SERVICES[nestedKey]);
    }
    return value && PROVIDER_SERVICES[key] ? [PROVIDER_SERVICES[key]] : [];
  });
};

function shuffleProviderServices(
  attributes: SEOSegmentationProviderSearchResult['seniorAssistedLivingCenterAttributes']
) {
  if (!attributes) return [];

  const services = convertServicesToStrings(attributes);
  const rooms = convertServicesToStrings(attributes.rooms);
  const providerServicesList = [...services, ...rooms].filter((item) => item !== undefined);

  return shuffle(providerServicesList.slice(0, 6));
}

export default shuffleProviderServices;
